import { Analytics } from '@segment/analytics-node'
import { getUserId } from "../Authentication";

const segmentOptions = {
  writeKey: process.env.REACT_APP_SEGMENT_KEY,
};

const analytics = new Analytics(segmentOptions);

const safeTrack = async (eventName, otherProperties) => {
  try {
    const properties = {
      url: `${window.location.origin}${window.location.pathname}`,
      timestamp: new Date().toISOString(),
      ...otherProperties,
    };
    analytics.track({
      userId: getUserId(),
      event: eventName,
      properties,
    });
    await analytics.flush()
  } catch (err) {
    console.warn('Analytics track failed:', err);
  }
};

export {
  safeTrack
}
